import { useTranslation } from 'next-i18next';
import { GlobalLink } from '../../domain/static-content/static-content.static-generation.model';
import styles from './section-link.module.scss';
import { useRouter } from 'next/router';
import { usePathname } from 'next/navigation';

export const SectionLink = (link: GlobalLink) => {
  const { t } = useTranslation('shared');
  const router = useRouter();
  const path = usePathname();

  let url: URL | undefined;
  try {
    url = new URL(link.url);
    // Set backUrl param for the customer support page link
    if (link.url.includes(`customer-support`)) {
      url.searchParams.set('backUrl', path);
    }
  } catch (error) {
    console.error(`Failed to parse Footer Link URL "${link.url}":`, error);
  }

  return (
    <li>
      <a
        key={link.id}
        href={url?.href ?? link.url}
        className={styles['inline-link-standalone']}
        target={link.url.startsWith('https://app.stihl') ? '_self' : '_blank'}
        rel="noreferrer"
        aria-current={url?.pathname === router.asPath ? 'page' : undefined}
      >
        {link.name}
        {!link.url.startsWith('https://app.stihl') && <span className="sr-only">{t('shared_a11y_hint_opensInNewTab')}</span>}
      </a>
    </li>
  );
};
